import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { ClipboardList, AlertCircle } from 'lucide-react';
import EmployeeReportsPage from './EmployeeReportsPage';
import IncidentsPage from './IncidentsPage';

export default function SegnalazioniPage() {
  return (
    <div className="space-y-4" data-testid="segnalazioni-page">
      <h1 className="text-2xl font-bold text-slate-900">Gestione Segnalazioni</h1>
      <Tabs defaultValue="dipendenti">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="dipendenti" data-testid="tab-segnalazioni-dipendenti" className="flex items-center gap-2">
            <ClipboardList size={16} />
            Segnalazioni Dipendenti
          </TabsTrigger>
          <TabsTrigger value="cantiere" data-testid="tab-segnalazioni-cantiere" className="flex items-center gap-2">
            <AlertCircle size={16} />
            Segnalazioni Cantiere
          </TabsTrigger>
        </TabsList>
        <TabsContent value="dipendenti">
          <EmployeeReportsPage embedded />
        </TabsContent>
        <TabsContent value="cantiere">
          <IncidentsPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
